import React, { useEffect, useState } from 'react'
import * as d3 from 'd3'
import { ChartWrapper } from './ChartStyles'
import { ChartProps } from './interface'

import { ChartLines } from './helpers/Chart'
import { Candles } from './helpers/Candles'

export default function Chart({
  value,
  bet,
  focused,
  autoConfig,
  history,
}: ChartProps) {
  const { my } = history
  const [min] = useState(0)
  const [max] = useState(100)
  const [width] = useState(352)
  const [height] = useState(200)
  const [showHistory, setShowHistory] = useState(true)
  const [curValue, setCurValue] = useState(Number(value))
  const [heightTop, setHeightTop] = useState(0)
  const [heightBottom, setHeightBottom] = useState(0)
  const [data, setData] = useState([{}])
  const [historyData, setHistoryData] = useState<any[]>([])
  const [deltaIndex, setDelta] = useState(-1)
  const [animate, setAnimate] = useState(true)
  const [showCandles, setShowCandles] = useState(true)
  const [lastBetId, setlastBetId] = useState('')
  const [verticalPos] = useState([
    32.84, 80.56, 128.3, 176.4, 223.78, 271.52, 319.26,
  ])
  const [horizontalPos] = useState([30.06, 65.03, 99.94, 134.98, 169.96])

  // data sample for candle
  // const data = [
  //   { y: 10, win: true, rollOver: true }
  // ]
  const scale = d3
    .scaleLinear()
    .domain([0, 10000]) // input
    .range([5, 50]) // output

  // set candle data after bet
  useEffect(() => {
    if (bet.bet !== '0') {
      const betCandle = {
        y: bet.rolled,
        win: bet.win > 0 ? true : false,
        rollOver: bet.over_or_under != 0 ? true : false,
        id: bet.bet_id,
      }
      setData([betCandle])
      setHistoryData([...historyData, betCandle])
      setDelta(deltaIndex + 1)
      setShowHistory(false)
    }
  }, [bet])

  useEffect(() => {
    if (showHistory && my.length) {
      setlastBetId(my[0].bet_id)
    }
  }, [my])

  useEffect(() => {
    if (
      showHistory &&
      my.length &&
      curValue * 100 == my[0].roll &&
      lastBetId !== my[0].bet_id
    ) {
      const historyCandle = {
        y: scale(my[0].number),
        win: my[0].winCoef > 0 ? true : false,
        rollOver: my[0].up != 0 ? true : false,
        id: my[0].bet_id,
      }
      setData([historyCandle])
      setDelta(deltaIndex + 1)
    }
  }, [my, lastBetId])

  // draw candles on index change
  useEffect(() => {
    DrawCandle()
  }, [data])

  // clears chart on current value change and draws new one
  useEffect(() => {
    const yScale = d3
      .scaleLinear()
      .domain([min, max]) // input
      .range([50, height - 50]) // output

    const middleLine = yScale(curValue)
    setHeightTop(height - middleLine)
    setHeightBottom(middleLine)
  }, [curValue, animate])

  useEffect(() => {
    setDelta(-1)
    DrawChart()
  }, [heightTop])

  useEffect(() => {
    deltaIndex !== -1 && DrawCandle()
  }, [deltaIndex])

  // changes current value on slide change
  useEffect(() => {
    setCurValue(value)
  }, [value])

  // clear chart on roll change
  useEffect(() => {
    const val = curValue
    if (val !== value) {
      focused
        ? (SetHistoryData(), setShowCandles(false))
        : (ClearHistory(), setShowCandles(true))
    }
  }, [focused])

  const SetHistoryData = () => {
    setData(historyData)
    setTimeout(() => {
      setAnimate(false)
    }, 10)
    setTimeout(() => {
      ClearHistory()
    }, 100)
  }
  const ClearHistory = () => {
    setAnimate(true)
    setHistoryData([])
    setTimeout(() => {
      setDelta(-1)
    }, 10)
  }

  const DrawChart = () => {
    ClearChart()
    ChartLines({
      verticalPos,
      heightTop,
      heightBottom,
      horizontalPos,
      curValue,
      width,
      height,
      animate,
      min,
      max,
    })
  }
  const ClearChart = () => d3.select('.chart').selectAll('svg').remove()

  const RemoveText = () => d3.select('.chart').select('.middleText').remove()
  const DrawCandle = () => {
    RemoveText()
    Candles({ deltaIndex, data, heightTop, showCandles })
  }

  return (
    <ChartWrapper
      heightTop={heightTop}
      heightBottom={heightBottom}
      autoConfig={autoConfig}
    >
      <div className='chart'>
        <div className='top'></div>
        <div className='bottom'></div>
        <div className='text-wrapper'></div>
      </div>
    </ChartWrapper>
  )
}
